import { Fragment } from "react";

import useAccountCreationUserInfo from "./UseAccountCreationUserInfo";

import UserInfoForm from "../../components/forms/UserInfoForm";
import PersonDupPopupManager from "../../components/dialogs/PersonDupPopupManager";

import Headings from "@usas/ui-web/components/headings/Headings";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import Constants from "@usas/ui-web/utils/Constants";

const AccountCreationUserInfo = () => {
  const {
    isLoading,
    userInfoData,
    childData,
    isUserUnder16,
    apiErrorPopupState,
    dupCheckState,
    onBackClicked,
    onDupCheckPopupCancelClicked,
    onDupCheckPopupForgotUsernameClicked,
    onDupCheckPopupContinueClicked,
    onCloseAPIErrorPopupClicked,
    onSubmitFormCallback
  } = useAccountCreationUserInfo();

  return (
    <Fragment>
      <div className="usas-extra-bottom-margin">
        <Headings.H3>User Info</Headings.H3>
        <p>Please supply the following information.</p>
      </div>
      <UserInfoForm
        userInfoData={userInfoData}
        childData={childData}
        isUserUnder16={isUserUnder16}
        onSubmitFormCallback={onSubmitFormCallback}
        onSecondaryButtonClicked={onBackClicked} />
      {(apiErrorPopupState.displayPopup === false && dupCheckState.isObjLoaded === true && dupCheckState.objData?.matches?.length > 0 && dupCheckState.objData.errorMessage === null) &&
        <PersonDupPopupManager
          dupCheckState={dupCheckState}
          isMemberIdDupCheck={userInfoData?.memberId ? true : false}
          onContinueClicked={onDupCheckPopupContinueClicked}
          onForgotUsernameClicked={onDupCheckPopupForgotUsernameClicked}
          onCancelClicked={onDupCheckPopupCancelClicked}
          onLinkPersonClicked={onDupCheckPopupContinueClicked} />
      }
      <PopUpModal
        widthPct={60}
        maxWidth={720}
        title={'Error'}
        displayPopUp={apiErrorPopupState.displayPopup === true}>
        <div className="row">
          <div className="col-xs-12">
            <p>{apiErrorPopupState.errorMessage || 'An error occurred.'}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <SecondaryButton type={'button'} onClick={onCloseAPIErrorPopupClicked}>Close</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default AccountCreationUserInfo;